import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { PDFDocument } from 'pdf-lib';

@Component({
  selector: 'app-cierre-doc',
  templateUrl: './cierre-doc.component.html',
  styleUrls: ['./cierre-doc.component.scss']
})
export class CierreDocComponent implements OnInit {

  pdfView: Uint8Array;
  pdfSrc = 'assets/cierre-virtual-cliente.pdf';
  pdfBytes: Uint8Array;
  fileName: string;
  fileUrl: any;

  @Input() data:any;

  constructor( private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    
  }

  ngOnChanges(){
    if(this.data){
      this.createPDFContract(this.data);
    }
    
  }

  async createPDFContract(data:any){
    let datePipe = new DatePipe('en-US');

    let existingPDFBytes = await fetch(this.pdfSrc).then(res => res.arrayBuffer());

    const pdfDoc = await PDFDocument.load(existingPDFBytes);

    const form = pdfDoc.getForm();
    const fields = form.getFields();
    

    fields.forEach(field => {

      const name = field.getName();

      if(name.includes(".")){
        let objectKeys = name.split(".");
        let val = data;
        for(let key of objectKeys){
          var lastChar = key.charAt(key.length - 1);
          if(parseInt(lastChar)){
            let pos = parseInt(lastChar)-1;
            key = key.slice(0, -1)
            val = val[key][pos] || '';
          }else{
            if(key == 'birthDate'){
              if(val[key]){
                let date:any = new Date(val[key]);
                date.setDate(date.getDate() + 1); // fix off 1 day error ¿Why?
                val =  datePipe.transform(date, 'MM-dd-yyyy');
              }else{
                val = ''
              }
            }
            else if(key == 'physicalAddress'){
              val = val['physicalAddress1']  + ' ' + val['physicalAddress2'];
            }
            else if(key == 'postalAddress'){
              val = val['postalAddress1']  + ' ' + val['postalAddress2'];
            }
            else{
              // console.log(key);
              val = val[key] || '';
            }
            
          }
          if(val){
            form.getTextField(name).setText(val.toString());
          } else{
            form.getTextField(name).setText('');
          }
          
          
        }
        // console.log(val);
      }else{
        
        
        // console.log(name);
       
        
        if(name == 'prestamoInicio' || name == 'prestamoCulminacion'){
          console.log('date');
          let date:any = datePipe.transform(data[name], 'MM-dd-yyyy');
          form.getTextField(name).setText(date);
        }else if(name == 'fecha_cierre'){
          let date:any = datePipe.transform(new Date(), 'MM-dd-yyyy');
          form.getTextField(name).setText(date);
        }else if(data[name] == null) return;
        else{
          form.getTextField(name).setText(data[name].toString());
        }
        
        
      }
      

    })
    this.fileName = `cierre-virtual-Central-Credit-${data.insCompany}-${data.insName}-${data.qDateEffective}`;

    // form.flatten();
    
    this.pdfBytes = await pdfDoc.save()
    
    const blob = new Blob([this.pdfBytes], { type: 'application/pdf' });

    this.fileUrl = this.sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(blob));

    const fileReader = new FileReader();
    fileReader.onload = () => {
      this.pdfView = new Uint8Array(fileReader.result as ArrayBuffer);
    };
    fileReader.readAsArrayBuffer(blob);  

    
  }

}
